import './css/ad.css';



import AnimeShapes1 from './images/products/1.jpg';
import AnimeShapes2 from './images/products/2.jpg';
import AnimeShapes3 from './images/products/3.jpg';

function Ad(){
    return(
        <>
        
            <section className="ads">
                    <div className="row">
                        <div className="col-lg-3 col-md-3 col-sm-12 col-xs-12">
                            <div  data-aos="fade-left" className="ad">
                                <a href="#">
                                    <img src={AnimeShapes1} alt="animeproduct"/>                  
                                    <div className="info">
                                        <h1> منتجات يابانية </h1>
                                        <p> جميع المنتجات اليابانية في مكان واحد </p>
                                    </div>
                                </a>
                            </div>
                        </div>


                        <div className="col-lg-3 col-md-3 col-sm-12 col-xs-12">
                            <div data-aos="fade-right" className="ad">
                                <a href="#">
                                    <img src={AnimeShapes2} alt="animeproduct"/>                  
                                    <div className="info">
                                        <h1> منتجات يابانية </h1>
                                        <p> جميع المنتجات اليابانية في مكان واحد </p>
                                    </div>
                                </a>
                            </div>
                        </div>




                        <div className="col-lg-6 col-md-6 col-sm-12 col-xs-12">
                            <div data-aos="fade-left" className="ad">
                                <a href="#">
                                <img src={AnimeShapes3} alt="animeproduct"/>                  
                                <div className="info">
                                        <h1> منتجات يابانية </h1>
                                        <p> جميع المنتجات اليابانية في مكان واحد </p>
                                    </div>
                                </a>
                            </div>
                        </div>
                    </div>
            </section>


        </>
    )
}

export default Ad;